import { AppId } from '@wix/cashier-common/dist/src/enums/AppId';
import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { Experiment } from '../../types/Experiment';

export const isPayModalEnabled = (appId: string): boolean => {
  if (
    appId === AppId.Stores &&
    !experimentsService.isExperimentEnabled(Experiment.EnablePayModalForStores)
  ) {
    return false;
  }

  return true;
};
